import { ACTIONS } from "UTILS/Constants";

const initialState = {
  operatorStatus: 'WAITING',
  sessionDetails: {
    sessionId: null,
    sessionName: "",
    sessionKey: "",
    sessionCreatedTime: null,
    isTransfer: false,
    requirement: null,
  },
  numberOfCallsWaiting: 0,
  transferDestinationOperatorList: [],
  isTransferError: false,
  isWebWorkerError: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SUPPORT_CENTER.SET_OPERATOR_STATUS:
      return {
        ...state,
        operatorStatus: action.value
      };
    case ACTIONS.SUPPORT_CENTER.SET_SESSION_DETAILS:
      return {
        ...state,
        sessionDetails: action.value
      };
    case ACTIONS.SUPPORT_CENTER.SET_NUMBER_OF_CALLS_WAITING:
      return {
        ...state,
        numberOfCallsWaiting: action.value
      };
    case ACTIONS.SUPPORT_CENTER.SET_CALL_TRANSFER_INFO:
      return {
        ...state,
        transferDestinationOperatorList: action.value
      };
    case ACTIONS.SUPPORT_CENTER.SET_IS_TRANSFER_ERROR:
      return {
        ...state,
        isTransferError: action.value
      };
    case ACTIONS.SUPPORT_CENTER.SET_IS_WEB_WORKER_ERROR:
      return {
        ...state,
        isWebWorkerError: action.value
      };
    default:
      return state;
  }
}
